/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceCreateWorkItemStep.Props" />
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IBoardInfo } from "Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/FirstRunExperiencePanel.Props";
import { IFirstRunExperienceStepBasicProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceStep.Props";

export interface IFirstRunExperienceCreateWorkItemStepProps extends IFirstRunExperienceStepBasicProps {
    projectId: string;
    boardInfo: IBoardInfo;
    onStepProcessing?: () => void;
    onStepSucceeded?: (workItem: WorkItem) => void;
    onStepFailed?: (errorMessage: string) => void;
}
